var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 10.9092C0.375 9.50959 1.50959 8.375 2.90917 8.375C4.30875 8.375 5.44334 9.50959 5.44334 10.9092V11.9888H0.375V10.9092Z",
    stroke: "#1E334E",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5566 10.9092C10.5566 9.50959 11.6912 8.375 13.0908 8.375C14.4904 8.375 15.625 9.50959 15.625 10.9092V11.9888H10.5566V10.9092Z",
    stroke: "#1E334E",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 7.27342C9.60668 7.27342 10.9092 5.97094 10.9092 4.36425C10.9092 2.75756 9.60668 1.45508 7.99999 1.45508C6.3933 1.45508 5.09082 2.75756 5.09082 4.36425C5.09082 5.97094 6.3933 7.27342 7.99999 7.27342Z",
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13574 12.3638C4.13574 10.2299 5.8656 8.5 7.9995 8.5C10.1334 8.5 11.8633 10.2299 11.8633 12.3638V14.0456H4.13574V12.3638Z",
    fill: "white",
    stroke: "#1E334E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0913 7.2744C13.8946 7.2744 14.5459 6.62316 14.5459 5.81982C14.5459 5.01647 13.8946 4.36523 13.0913 4.36523C12.288 4.36523 11.6367 5.01647 11.6367 5.81982C11.6367 6.62316 12.288 7.2744 13.0913 7.2744Z",
    fill: "#F7931E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90966 7.2744C3.71301 7.2744 4.36425 6.62316 4.36425 5.81982C4.36425 5.01647 3.71301 4.36523 2.90966 4.36523C2.10632 4.36523 1.45508 5.01647 1.45508 5.81982C1.45508 6.62316 2.10632 7.2744 2.90966 7.2744Z",
    fill: "#F7931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.691fafe83e3e493bf140d4da6a68198f.svg";
export { ForwardRef as ReactComponent };